import { render, staticRenderFns } from "./CreateAccountAction.vue?vue&type=template&id=bcc5f0fc&scoped=true&"
import script from "./CreateAccountAction.vue?vue&type=script&lang=ts&"
export * from "./CreateAccountAction.vue?vue&type=script&lang=ts&"
import style0 from "./CreateAccountAction.vue?vue&type=style&index=0&id=bcc5f0fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc5f0fc",
  null
  
)

export default component.exports